import React from 'react';
import { Box } from '@chakra-ui/react';
interface SectionFadeProps {
  /** Flip the gradient so the glow sits at the top edge instead of the bottom. */
  flip?: boolean;
}

/**
 * Soft fire-tinted transition placed between sections so they blend
 * into one another instead of cutting hard.
 */
export function SectionFade({
  flip = false
}: SectionFadeProps) {
  return <Box aria-hidden="true" h={{
    base: '80px',
    md: '120px'
  }} w="full" bgGradient={flip ? 'linear(to-b, rgba(184, 41, 26, 0.18), transparent)' : 'linear(to-b, transparent, rgba(184, 41, 26, 0.18))'} position="relative" _after={{
    content: '""',
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
    bottom: flip ? 'auto' : 0,
    top: flip ? 0 : 'auto',
    w: '70%',
    h: '1px',
    bgGradient: 'linear(to-r, transparent, rgba(232, 99, 26, 0.55), transparent)'
  }} data-id="element-16" data-mp="3t3duaxopo3mn" />;
}